<template>
  <svg width="48" height="42" viewBox="0 0 48 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.3504 32.3077H6.4C5.9328 32.3077 5.54933 32.1564 5.2496 31.8538C4.94987 31.5512 4.8 31.164 4.8 30.6923V3.23077H1.6C1.1328 3.23077 0.749333 3.07946 0.4496 2.77685C0.149867 2.47423 0 2.08708 0 1.61538C0 1.14369 0.149867 0.756539 0.4496 0.453923C0.749333 0.151308 1.1328 0 1.6 0H46.4C46.8672 0 47.2507 0.151308 47.5504 0.453923C47.8501 0.756539 48 1.14369 48 1.61538C48 2.08708 47.8501 2.47423 47.5504 2.77685C47.2507 3.07946 46.8672 3.23077 46.4 3.23077H43.2V30.6923C43.2 31.164 43.0501 31.5512 42.7504 31.8538C42.4507 32.1564 42.0672 32.3077 41.6 32.3077H31.6496L37.2 42H33.4992L27.9488 32.3077H20.048L14.4976 42H10.7968L16.3504 32.3077ZM40 3.23077H8V29.0769H40V3.23077ZM15.5504 20.5461C15.2165 20.8487 14.8331 21 14.4 21C13.9669 21 13.592 20.8401 13.2752 20.5202C12.9584 20.2004 12.8 19.8218 12.8 19.3846C12.8 18.9474 12.9499 18.5602 13.2496 18.2232L20.6496 10.8021L26.8992 15.5481L32.3488 8.68269C32.7488 8.17762 33.2571 7.96708 33.8736 8.05108C34.4901 8.13508 34.9067 8.47162 35.1232 9.06069C35.3397 9.64977 35.248 10.1968 34.848 10.7019L27.4976 19.9904L20.9472 15.0425L15.5504 20.5461Z" fill="#43D3B3"/>
  </svg>
</template>

<script>
export default {
  name: 'Sales',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
